import { render, staticRenderFns } from "./MattReGI.vue?vue&type=template&id=96704dc2"
import script from "./MattReGI.vue?vue&type=script&lang=js"
export * from "./MattReGI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports